<template>
  <transition>
    <section class="About">
      <!-- <div class="col-xs col-sm-5"> -->
      <div class="row">
        <FadeRight appear>
          <h1 class="col-sm-offset-5">&mdash; About.</h1>
        </FadeRight>
      </div>
      <div class="row">
        <Fade appear>
          <div class="bodyText col-xs-9 col-sm-offset-1 col-sm-2">
            <p>
              I'm Robbey, an Interface Designer at
              <a class="animateLink hoverLink" href="https://www.snapchat.com"
                >Snapchat</a
              >
              with a degree from the University of Texas School of Architecture
              and studies from ExLab at the Melbourne School of Design. I've
              previously worked at
              <a class="animateLink hoverLink" href="https://www.HYPR.com"
                >HYPR</a
              >
              and done projects with other startups.
            </p>
            <p>
              When not at a computer designing, I'm usually in the wilderness
              photographing the natural world.
            </p>
            <p>
              I'm looking for new challenges with a consumer focus. If you're
              working on something meaningful &mdash; Let's have a chat.
            </p>

            <p>
              <a
                href="mailto:hello@robbeyorth.com"
                class="iconLink"
                aria-label="Send me an email"
              >
                <i class="far fa-envelope"></i>
              </a>
              &emsp;
              <a
                href="https://www.instagram.com/robbey.o/"
                class="iconLink"
                aria-label="Check out my Instagram"
              >
                <i class="fab fa-instagram"></i>
              </a>
              <!-- &emsp;
              <a
                href="https://angel.co/robbey-orth"
                class="iconLink"
                aria-label="Check out my Angel.co"
              >
                <i class="fab fa-angellist"></i>
              </a> -->
              &emsp;
              <a
                href="https://www.linkedin.com/in/robbeyorth/"
                class="iconLink"
                aria-label="Check out my LinkedIn"
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </p>

            <p>&mdash;</p>
            <p>
              This site was hand-built with open-source libraries,
              <a class="animateLink hoverLink" href="https://www.vuejs.org"
                >Vue.js</a
              >, and plenty of 🍵.
            </p>
          </div>
        </Fade>
        <!-- </div> -->
        <FadeLeft appear>
          <div class="col-xs-9 col-sm-offset-1 col-sm-4 first-xs last-sm">
            <img
              class="profileImage"
              src="../assets/Headshot.jpg"
              alt="Headshot of Robbey"
            />
          </div>
        </FadeLeft>
      </div>
    </section>
  </transition>
</template>
<script>
import FadeLeft from "@/transitions/FadeLeft.vue";
import FadeRight from "@/transitions/FadeRight.vue";
import Fade from "@/transitions/Fade.vue";

export default {
  name: "AboutSection",
  components: {
    FadeLeft,
    FadeRight,
    Fade
  }
};
</script>

<style scoped lang="scss">
// * {
//   border: 1px solid red;
// }
.About {
  height: 100vh;
  margin: 6.75rem auto !important;

  h1 {
    margin-bottom: 2rem;
    @include respond-to(sm) {
      margin: 5.5rem -1.4% 6rem 0;
    }
    font-size: 3rem;
  }
  p {
    font-size: 1.125rem;
    color: $dark-grey;
  }
}

.bodyText {
  padding: 0 8px 8vh 8px;
  max-width: 60ch;
  margin-top: -1rem;
  // @include respond-to(xs) {

  // }
  // @include respond-to(sm) {
  //   padding: 8px;
  // }
  // padding: auto;
}

.profileImage {
  max-width: 100%;
  object-fit: contain;
  padding: 3rem $gutter 0 $gutter;

  @include respond-to(md) {
    padding: 0 $gutter 3rem 0;
    vertical-align: top;
  }
  @include respond-to(lg) {
    max-height: 72vh;
  }
}

.hoverLink {
  color: $mid-grey;
  font-family: $display-font-stack;
  font-style: italic;
  font-size: 1.25rem;
  &:hover {
    text-decoration: none;
    color: $brand-blue;
  }
  &:visited {
    color: $mid-grey;
  }
}

.iconLink {
  color: $mid-grey;
  font-size: 1.5rem;
  &:hover {
    text-decoration: none;
    color: $brand-blue;
  }
  &:visited {
    color: $mid-grey;
  }
}
</style>
